import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=e34b82b6"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e34b82b6')) {
      api.createRecord('e34b82b6', component.options)
    } else {
      api.reload('e34b82b6', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=e34b82b6", function () {
      api.rerender('e34b82b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/inform/detail.vue"
export default component.exports